import {createAnatomy} from '@zag-js/anatomy';

export const listAnatomy = createAnatomy(`list`).parts(
  `bullet`,
  `label`,
  `value`,
  `percentage`,
  `container`,
  `item-container`,
  `item-content`,
);

export const parts = listAnatomy.build();

export type Part = keyof typeof parts;
